import { getConfig } from "./config";

const getAuthHeaders = () => ({
    "Content-Type": "application/json",
});

const parseResponse = async (res) => {
    const data = await res.json();

    if (!res.ok) {
        return {
            Success: false,
            Message: data?.Message || data?.message || "Request failed.",
            ...data,
        };
    }

    return data;
};

export const getAllTestimonials = async () => {
    try {
        const config = await getConfig();

        const res = await fetch(
            `${config.baseUrl}${config.testimonial.getAll}`,
            {
                headers: getAuthHeaders(),
                cache: "no-store",
            }
        );

        return await parseResponse(res);
    } catch (error) {
        return {
            Success: false,
            Message: error.message,
        };
    }
};

export const addOrEditTestimonial = async (payload) => {
    try {
        const config = await getConfig();

        const res = await fetch(
            `${config.baseUrl}${config.testimonial.addOrEdit}`,
            {
                method: "POST",
                headers: getAuthHeaders(),
                body: JSON.stringify(payload),
            }
        );

        return await parseResponse(res);
    } catch (error) {
        return {
            Success: false,
            Message: error.message,
        };
    }
};

export const approveTestimonial = async (testimonialId) => {
    try {
        const config = await getConfig();

        const res = await fetch(
            `${config.baseUrl}${config.testimonial.approve}`,
            {
                method: "POST",
                headers: getAuthHeaders(),
                body: JSON.stringify({ testimonialId }),
            }
        );

        return await parseResponse(res);
    } catch (error) {
        return {
            Success: false,
            Message: error.message,
        };
    }
};

export const rejectTestimonial = async (testimonialId) => {
    try {
        const config = await getConfig();

        const res = await fetch(
            `${config.baseUrl}${config.testimonial.reject}`,
            {
                method: "POST",
                headers: getAuthHeaders(),
                body: JSON.stringify({ testimonialId }),
            }
        );

        return await parseResponse(res);
    } catch (error) {
        return {
            Success: false,
            Message: error.message,
        };
    }
};
